import { onMounted, onScopeDispose } from 'vue';
import { useQueryClient } from '@tanstack/vue-query';

import { useEventHub } from '@satellite/composables/useEventHub';
import { WEBSOCKET_RECONNECTED_EVENT } from '@satellite/helpers/socketEventTypes';
import { trackDatadogRumAction } from '@/plugins/datadogRumPlugin';

import type { WebsocketReconnectedPayload } from '@satellite/helpers/socketEventTypes';

/**
 * Invalidates every query when the websocket reconnects, since events sent while it was down are
 * not replayed, and records the reconnect as a RUM action. Call from a component `setup`.
 */
export function useRefetchOnSocketReconnect() {
  const eventHub = useEventHub();
  const queryClient = useQueryClient();

  const handleSocketReconnected = (payload?: WebsocketReconnectedPayload) => {
    trackDatadogRumAction('websocket_reconnected', {
      attempts: payload?.attempts ?? null,
      disconnectedForMs: payload?.disconnectedForMs ?? null,
      disconnectReason: payload?.disconnectReason ?? null,
      visibilityState: document.visibilityState
    });
    queryClient.invalidateQueries();
  };

  onMounted(() => {
    eventHub.on(WEBSOCKET_RECONNECTED_EVENT, handleSocketReconnected);
  });

  onScopeDispose(() => {
    eventHub.off(WEBSOCKET_RECONNECTED_EVENT, handleSocketReconnected);
  });
}
